<template>
  <div class="stat-bar-chart">
    <div class="chart-title">{{ title }}</div>
    <VChart v-if="rows.length" class="chart" :option="option" autoresize />
    <div v-else class="chart-empty">{{ emptyText }}</div>
  </div>
</template>

<script>
import { computed } from 'vue';
import VChart from '@/components/charts/echarts';

export default {
  name: 'StatBarChart',
  components: { VChart },
  props: {
    title: { type: String, default: '' },
    rows: { type: Array, default: () => [] },
    valueFormatter: { type: Function, default: (v) => v },
    color: { type: String, default: '#3b82f6' },
    emptyText: { type: String, default: 'Нет данных' },
    height: { type: Number, default: 320 },
  },
  setup(props) {
    const option = computed(() => ({
      // Фиксированный правый отступ — одинаковая ширина plot-area у всех
      // графиков независимо от длины value-лейблов (выравнивание сетки 2×2).
      grid: { left: 8, right: 76, top: 8, bottom: 8, containLabel: true },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        confine: true,
        formatter: (params) => {
          const item = Array.isArray(params) ? params[0] : params;
          return `<b>${item.name}</b><br/>${props.valueFormatter(item.value)}`;
        },
      },
      xAxis: { type: 'value', axisLabel: { formatter: (v) => props.valueFormatter(v) } },
      yAxis: {
        type: 'category',
        inverse: true,
        data: props.rows.map((row) => row.label),
        axisLabel: {
          width: 190,
          overflow: 'truncate',
          fontSize: 12,
          color: '#475467',
        },
      },
      series: [
        {
          type: 'bar',
          data: props.rows.map((row) => row.value),
          itemStyle: { color: props.color, borderRadius: [0, 4, 4, 0] },
          barMaxWidth: 22,
          label: {
            show: true,
            position: 'right',
            formatter: (p) => props.valueFormatter(p.value),
            fontSize: 11,
            color: '#475467',
          },
        },
      ],
    }));

    return { option };
  },
};
</script>

<style scoped>
.stat-bar-chart {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  box-sizing: border-box;
}

.chart-title {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.chart {
  width: 100%;
  height: v-bind('height + "px"');
}

.chart-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: v-bind('height + "px"');
  color: #98a2b3;
  font-size: 14px;
}
</style>
